<template>
  <section class="about-section">
    <div class="container">
      <h1 class="main-title">About StreamBox</h1>

      <div class="section-block">
        <h2>What is StreamBox?</h2>
        <p>
          StreamBox is a modern IPTV platform built to provide users with a flexible, powerful,
          and visually appealing way to manage and enjoy TV channels, video-on-demand, radio, and more.
          It does not provide any built-in content. All promotional content is for demonstration only.
        </p>
        <p>
          Users can upload and organize their own playlists with ease. StreamBox supports both end users
          and IPTV providers by offering a customizable platform and an optional admin panel.
        </p>
      </div>

      <div class="section-block">
        <h2>Key Features</h2>
        <ul>
          <li>Intuitive and fast remote-friendly interface</li>
          <li>Live TV with EPG and catch-up support</li>
          <li>VOD categorization and movie/series support</li>
          <li>Radio station streaming</li>
          <li>End-user playlist management</li>
          <li>Multi-language UI support</li>
        </ul>
      </div>

      <div class="section-block-platform">
        <h2>Available Platforms</h2>
        <ul>
          <li><img src="@/assets/android.png" alt="Android TV" class="platform-logo" /> Android TV</li>
          <li><img src="@/assets/google.png" alt="Google TV" class="platform-logo" /> Google TV</li>
          <li><img src="@/assets/amazonFireTV.png" alt="Amazon Fire TV" class="platform-logo" /> Amazon Fire TV</li>
  <li><img src="@/assets/samsung1.png" alt="Amazon Fire TV" class="platform-logo" /> Samsung Tizen TV</li>
          <li>LG webOS TV (coming soon)</li>
        </ul>
      </div>

      <div class="section-block">
        <div class="screenshot-grid">
          <img v-for="(s, i) in screenshots" :key="i" :src="s" alt="screenshot" @click="openImage(s)" />
        </div>
      </div>
    </div>

    <!-- Modal for screenshot preview -->
    <div v-if="showModal" class="modal-backdrop" @click.self="closeModal">
      <div class="modal-content">
        <img :src="currentImage" alt="Full Screenshot" />
        <button class="close-btn" @click="closeModal">✕</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutStreamBox",
  data() {
    return {
      screenshots: [
        require("@/assets/s1.png"),
        require("@/assets/s2.png"),
        require("@/assets/s5.png"),
        require("@/assets/s6.png"),
        require("@/assets/s14.png"),
        require("@/assets/s15.png"),
        require("@/assets/s8.png"),
        require("@/assets/Screen10.png"),
      ],
      showModal: false,
      currentImage: null,
    };
  },
  methods: {
    openImage(img) {
      this.currentImage = img;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.currentImage = null;
    },
  },
};
</script>

<style scoped>
.about-section {
  padding: 60px 20px;
  background-color: #0e0e0e;
  color: white;
  background: url("@/assets/back2.jpg") no-repeat center center;
  background-size: cover;
}

.container {
  max-width: 1100px;
  margin: auto;
}

.main-title {
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 40px;
  filter: drop-shadow(0 0 30px #0f3b99);
}

.section-block {
  margin-bottom: 50px;
}

.section-block h2 {
  color: #00ccff;
  margin-bottom: 20px;
}

.section-block ul {
  list-style: none;
  padding-left: 0;
  line-height: 1.8;
}

.section-block li::before {
  content: "\2022";
  color: #2a84ff;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}

.platform-logo {
  width: 120px;
}

.section-block-platform ul li {
  list-style-type: none;
  padding: 20px 0px;
}

.screenshot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.screenshot-grid img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.7);
  transition: 0.3s;
  cursor: pointer;
}
.screenshot-grid img:hover {
  transform: scale(1.03);
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  position: relative;
  max-width: 90%;
  max-height: 95%;
  padding: 10px;
  background-color: #111;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.8);
}

.modal-content img {
  max-width: 85%;
  max-height: 90vh;
  border-radius: 8px;

}

.close-btn {
  position: absolute;
  top: -12px;
  right: -5px;
  background: #ff0033;
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
</style>
